/**
 * Client-side Redux store - add to shared store with pageContents reducer
 */
import { createAppStore, thunkUserIp } from "@smfa/utils/src/store";
import logger from "redux-logger";
import pageContentReducer from "./slices/pageContentSlice";

// Shared utilities store:
export const { store, persistor } = createAppStore({
  reducers: {
    pageContents: pageContentReducer, // custom page content reducer
  },
  middleware: [logger],
  persistWhitelist: ["auth", "user", "pageContents"],
  // Initialize app after store creation
  afterCreate: (store) => {
    store.dispatch(thunkUserIp()); // Dispatch IP fetch
    // Make store available for non-component code
    window.store = store;
  },
});
